import { useParams } from 'react-router-dom';
import FileManager from '../components/FileManager';

function CasCycle() {
  const params = useParams();
  const cycleId = params.cycleId;  
  const folderId = "cas-" + cycleId;
  const folderName = cycleId + ". cyklus";

  return <>
    <FileManager folderId={folderId} folderName={folderName} />
  </>
}

export default CasCycle;